/**
 * @param {string || object} handled_by
 * @returns {bool || number}
 */
const getHandledByFilter = (handled_by) => {
  if (handled_by === 'all') {
    return undefined;
  }

  if (handled_by === 'no_owner') {
    return null;
  }

  if (handled_by) {
    return handled_by.id;
  }

  return undefined;
};

export default getHandledByFilter;
